import { AccountStatus } from "../detail/AccountStatus";
import AddTreatment from "./treatments/AddTreatment";
import TreatmentList from "./treatments/TreatmentList";
import { useEffect, useState } from "react";
import CurrentAccountBehaviourSettings from "../behaviour-settings/AccountBehaviourSettings";
import { useAccountIdContext } from "../AccountIdContext";
import { useAccountById, useRefreshAccountId } from "../../../sdk/ams";
import {  AccountTreatment, AccountFlag } from "../../../models/account";
import { toFormattedDateTime } from "@app/utilities";
import { Tab } from "semantic-ui-react";
import FlagList from "./flags/FlagList";
import AddFlag from "./flags/AddFlag";

type AccountTreatmentState = 'ACTIVE' | 'PENDING' | 'EXPIRED';
export type AccountTreatmentWithState = AccountTreatment & { state: AccountTreatmentState };
export type AccountFlagWithState = AccountFlag & { state: AccountTreatmentState };

export default function AccountState() {
    const { accountId, billingDate} = useAccountIdContext();
    const [minExpiryDate, setMinExpiryDate] = useState<Date | undefined>(new Date());
    const [activeTab, setActiveTab] = useState<number>(0);

    const {data: account, isFetching} = useAccountById(accountId);
    const refresh = useRefreshAccountId(accountId);

    const [activeTreatments, setActiveTreatments] = useState<AccountTreatmentWithState[]>([]);
    const [pendingTreatments, setPendingTreatments] = useState<AccountTreatmentWithState[]>([]);

    const [activeFlags, setActiveFlags] = useState<AccountFlagWithState[]>([]);

    useEffect(() => { 
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [billingDate]);

    
    useEffect(() => {
        if (account?.accountStatus?.accountTreatments) {
            setActiveTreatments(
                account.accountStatus.accountTreatments.map(treatment => ({...treatment, 
                    effectiveDate:  toFormattedDateTime(treatment.effectiveDate),
                    expiryDate: toFormattedDateTime(treatment.expiryDate),
                    state: 'ACTIVE'}))
            );
        }

        if (account?.pendingAccountTreatments) {
            setPendingTreatments(
                account.pendingAccountTreatments.map(treatment => ({...treatment, 
                    effectiveDate: toFormattedDateTime(treatment.effectiveDate),
                    expiryDate: toFormattedDateTime(treatment.expiryDate),
                    state: 'PENDING'}))
            );
        }

        if (account?.accountFlags) {
            setActiveFlags(
                account.accountFlags.map( flag => ({...flag,
                    effectiveDate: toFormattedDateTime(flag.effectiveDate),
                    expiryDate: toFormattedDateTime(flag.expiryDate),
                    state: 'ACTIVE'}))
            )
        }
    }, [account]);

    return (
        <section className="height full">
        {isFetching && <div className="ui active centered inline loader" />}

        {!isFetching &&<div className="ui grid">
            <div className="four wide column">
                <CurrentAccountBehaviourSettings behaviourSettings={account.accountStatus.behaviourSettings}/>
            </div>
            <div className="nine wide column">
                <Tab 
                activeIndex = {activeTab}
                onTabChange =  {(_, data) => setActiveTab(data.activeIndex as number)}
                panes={[
                        {
                        menuItem: 'Treatments',
                        render: () => (
                            <Tab.Pane>
                                <TreatmentList color="green" title='Active Treatments' activeTreatments={true} treatments={activeTreatments}/>
                                <div className={'ui divider'}></div>
                                <TreatmentList color="orange" title='Pending Treatments' activeTreatments={false} treatments={pendingTreatments}/>
                                <div className={'ui divider'}></div>
                            </Tab.Pane>
                        ),
                        },
                        {
                        menuItem: 'Flags',
                        render: () => (
                            <Tab.Pane>
                                <FlagList color="green" title='Active Flags' activeFlags={true} flags={activeFlags}/>
                                <div className={'ui divider'}></div>
                            </Tab.Pane>
                        ),
                        }
                    ]} />
            </div>
            <div className="three wide column">
                    <AccountStatus />
                    <AddFlag />
                    <AddTreatment/>
            </div>
        </div>
        }
        </section>
        );
}